import { useEffect } from "react";
import { Modal, Form } from "antd";
import PlanFormFields, { buildPlanPayload, planToFormValues } from "./PlanFormFields";

const EditSubscriptionPlanModal = ({ visible, loading, plan, onSubmit, onClose }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible && plan) {
            form.setFieldsValue(planToFormValues(plan));
        }
    }, [visible, plan, form]);

    const handleFinish = (values) => {
        const payload = buildPlanPayload(values, plan?.limits);
        delete payload.key;
        onSubmit(payload);
    };

    const handleAfterClose = () => {
        form.resetFields();
    };

    return (
        <Modal
            title={`Edit plan: ${plan?.name?.en || plan?.key || ""}`}
            open={visible}
            onCancel={onClose}
            onOk={() => form.submit()}
            confirmLoading={loading}
            width={840}
            afterClose={handleAfterClose}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <PlanFormFields isEdit />
            </Form>
        </Modal>
    );
};

export default EditSubscriptionPlanModal;
